.selectWrapper {
  position: relative;
  display: inline-flex;
  width: 100%;
}

.select {
  appearance: none;
  -webkit-appearance: none;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  color: var(--tuna-palette-text-primary);
  padding: 8.5px 36px 8.5px 14px;
  border: 1px solid var(--tuna-palette-action-disabled);
  border-radius: var(--tuna-shape-borderRadius);
  background: transparent;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  transition: border-color var(--tuna-transitions-duration-shorter) var(--tuna-transitions-easing-easeInOut);
}

.select:hover {
  border-color: var(--tuna-palette-text-primary);
}

.select:focus-visible {
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  padding: 7.5px 35px 7.5px 13px;
}

.error {
  border-color: var(--tuna-palette-error-main);
}

.select:disabled {
  color: var(--tuna-palette-text-disabled);
  border-color: var(--tuna-palette-action-disabledBackground);
  cursor: default;
}

.select:disabled ~ .arrow {
  opacity: 0.38;
}

.arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--tuna-palette-text-secondary);
  pointer-events: none;
  transition: border-color var(--tuna-transitions-duration-shorter) var(--tuna-transitions-easing-easeInOut);
}

.select:hover ~ .arrow {
  border-top-color: var(--tuna-palette-text-primary);
}

.select:focus-visible ~ .arrow {
  border-top-color: var(--tuna-palette-primary-main);
}

/* Legacy trigger class -- kept for backwards compat */
.selectTrigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  color: var(--tuna-palette-text-primary);
  padding: 8.5px 14px;
  padding-right: 32px;
  border: 1px solid var(--tuna-palette-action-disabled);
  border-radius: var(--tuna-shape-borderRadius);
  background: none;
  cursor: pointer;
  min-width: 120px;
  box-sizing: border-box;
}

.selectTrigger:hover {
  border-color: var(--tuna-palette-text-primary);
}

.selectTrigger:focus-visible {
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  padding: 7.5px 13px;
  padding-right: 31px;
  outline: none;
}

.formControl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  min-width: 0;
}

.inputLabel {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-secondary);
  transform-origin: top left;
  pointer-events: none;
}

.formLabel {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-palette-text-secondary);
  font-family: var(--tuna-typography-fontFamily);
}

.helperText {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
  font-family: var(--tuna-typography-fontFamily);
  margin: 3px 14px 0;
}

.helperTextError {
  color: var(--tuna-palette-error-main);
}

.textField {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  min-width: 0;
  flex: 1 1 auto;
}
